import { toast as sonnerToast } from 'sonner'

// Create a wrapper for the direct toast function to match the expected interface
export const toast = (options: { title: string; description?: string; variant?: 'default' | 'destructive' }) => {
  if (options.variant === 'destructive') {
    sonnerToast.error(options.title, {
      description: options.description,
    })
  } else {
    sonnerToast.success(options.title, {
      description: options.description,
    })
  }
}

// Keep the hook for backward compatibility
export const useToast = () => ({
  toast,
})
